import { useEffect } from 'react';

/**
 * Toast — bottom-right transient notification with an optional action button
 * (e.g. "Undo" after a delete). Auto-dismisses after `duration` ms.
 *
 * Props:
 *   toast      — { message, actionLabel?, onAction? } or null/undefined to render nothing
 *   onDismiss  — called when the toast should go away (timeout, action, or ✕)
 *   duration   — ms before auto-dismiss (default 6000)
 */
export default function Toast({ toast, onDismiss, duration = 6000 }) {
  useEffect(() => {
    if (!toast) return;
    const t = setTimeout(onDismiss, duration);
    return () => clearTimeout(t);
  }, [toast, duration, onDismiss]);

  if (!toast) return null;

  return (
    <div style={{
      position: 'fixed', bottom: '24px', right: '24px', zIndex: 2000,
      background: '#2c3e50', color: 'white', padding: '12px 16px', borderRadius: '6px',
      boxShadow: '0 4px 12px rgba(0,0,0,0.25)', display: 'flex', alignItems: 'center', gap: '14px',
      fontSize: '13px', maxWidth: '420px',
    }}>
      <span>{toast.message}</span>
      {toast.actionLabel && (
        <button
          onClick={() => { toast.onAction?.(); onDismiss(); }}
          style={{ background: 'none', border: '1px solid rgba(255,255,255,0.4)', color: 'white', borderRadius: '4px', padding: '4px 10px', cursor: 'pointer', fontSize: '12px', flexShrink: 0 }}
        >
          {toast.actionLabel}
        </button>
      )}
      <button
        onClick={onDismiss}
        style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,0.6)', cursor: 'pointer', fontSize: '14px', flexShrink: 0 }}
        aria-label="Dismiss"
      >✕</button>
    </div>
  );
}
